
import { Button } from "element-ui";
import { InfoIcon } from "vue-feather-icons";
import { PaymentHelper } from "@/helpers/PaymentHelper";

export default {
  data() {
    return {
      idealInstance: null,
      hipay: null,
      errors: [],
    };
  },
  computed: {
    defaultLocal() {
      return this.$i18n.locale;
    },
  },
  mounted() {
    try {
      this.initHipay();
      this.idealPayement();
    } catch (error) {}
  },
  methods: {
    initHipay() {
      this.hipay = HiPay({
        username: process.env.HIPAY_USERNAME,
        password: process.env.HIPAY_PASSWORD,
        environment: process.env.HIPAY_ENVIRONMENT,
        lang: this.defaultLocal,
      });
    },
    idealPayement() {
      const option = {
        selector: "hipay-ideal",
        template: "auto",
      };
      if (this.hipay != null) {
        this.idealInstance = this.hipay.create("ideal", option);
      }
    },
  },
  components: { Button, InfoIcon },
};
